import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '@intigral/domain/lib/DataDomain';
import { IApiPathManager } from '@intigral/domain/lib/infrastructures/config/ApiPathManager';
import { Carousel } from '@intigral/domain/lib/core/entities/ScreenEntities';
import type { ContentItem } from '../useContinueWatching';

type TaFeedEntry = {
    assetType?: string;
    stationId?: string;
    startTime?: string | number;
    listingId?: string;
    programType?: string;
};

export const isLinearTaEntry = (entry?: TaFeedEntry | null): boolean => {
    if (!entry) {
        return false;
    }
    if ((entry.assetType || '').toUpperCase() === 'LINEAR') {
        return true;
    }
    if ((entry.programType || '').toUpperCase() === 'LINEAR') {
        return true;
    }
    return !!(entry.stationId && (entry.startTime || entry.listingId));
};

export const getCarouselDatasourceProgramType = (carousel?: Carousel): string | null => {
    try {
        const datasource = carousel?.dataSources?.[0];
        if (!datasource) {
            return null;
        }
        const params = container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager).getParamsByDatasource(datasource);
        const paramValues = Array.isArray(params)
            ? params.map((param) => String(param?.value ?? '')).join('&')
            : String((params as { filter_params?: string })?.filter_params ?? params ?? '');
        const match = paramValues.match(/programType=([^&]+)/i);
        return match?.[1]?.toUpperCase() ?? null;
    } catch {
        return null;
    }
};

export const isLinearTaCarousel = (carousel?: Carousel, entries?: TaFeedEntry[]): boolean => {
    const datasourceProgramType = getCarouselDatasourceProgramType(carousel);
    if (datasourceProgramType === 'LINEAR') {
        return true;
    }
    if (datasourceProgramType === 'VOD') {
        return false;
    }
    return !!entries?.some(isLinearTaEntry);
};

export const isLinearContentItem = (item: ContentItem): boolean => {
    const linearItem = item as ContentItem & {
        stationId?: string;
        startTime?: string | number;
        listingId?: string;
        assetType?: string;
    };

    if (isLinearTaEntry(linearItem)) {
        return true;
    }

    return !!(linearItem.stationId && (linearItem.startTime || linearItem.listingId));
};

export const normalizeBookmarkList = (bookmarks: unknown): BookmarkEntry[] => {
    if (!bookmarks) {
        return [];
    }
    if (Array.isArray(bookmarks)) {
        return bookmarks as BookmarkEntry[];
    }
    if (typeof bookmarks === 'object' && Array.isArray((bookmarks as { entries?: unknown[] }).entries)) {
        return (bookmarks as { entries: BookmarkEntry[] }).entries;
    }
    return [];
};

type BookmarkEntry = {
    paId?: string;
    id?: string;
    guid?: string;
    timeCode?: number | string;
    timecode?: number | string;
    listings?: Array<{
        startTime?: string;
        endTime?: string;
        id?: string | number;
        stationId?: string;
    }>;
};
